// ============================================================================
// KpiGroup.jsx — Corelia UI v1.2
// Variante compacte (liste / grille KPI) basée sur InfoPanel
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";

const KpiGroup = ({
  groups = [],                // [{ label, value, color }]
  color = "white",            // palette globale fallback
  bordered = true,
  rounded = true,
  orientation = "horizontal", // "horizontal" ou "vertical"
  itemWidth = 140,
  itemHeight = 80,
  gap = theme.spacing.md,
  textSize = "medium",        // "small" | "medium"
  style = {},
  itemStyle = {},
}) => {

  const basePalette = theme.InfoPanel[color] || theme.InfoPanel.white;

  const resolvePalette = (c) =>
    theme.InfoPanel[c] || basePalette;

  // ————————————————————————————————————————————————
  // Typographies selon la variante
  // ————————————————————————————————————————————————
  const fontSizes =
    textSize === "small"
      ? { value: theme.fontSizes.md, label: theme.fontSizes.xs }
      : { value: theme.fontSizes.lg, label: theme.fontSizes.sm };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: orientation === "vertical" ? "column" : "row",
        flexWrap: "wrap",
        gap,
        justifyContent: "flex-start",
        alignItems: "stretch",
        ...style,
      }}
    >
      {groups.map((kpi, index) => {
        const palette = resolvePalette(kpi.color);

        return (
          <div
            key={index}
            style={{
              width: typeof itemWidth === "number" ? `${itemWidth}px` : itemWidth,
              height: typeof itemHeight === "number" ? `${itemHeight}px` : itemHeight,

              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",

              // Palette InfoPanel
              backgroundColor: palette.bg,
              border: bordered ? `1px solid ${palette.border}` : "none",
              borderRadius: rounded ? theme.borders.radius.lg : 0,
              boxShadow: theme.shadows.xs,
              color: palette.text,
              textAlign: "center",

              ...itemStyle,
            }}
          >
            {/* Valeur */}
            <div
              style={{
                fontSize: fontSizes.value,
                fontWeight: theme.fontWeights.semiBold,
                color: palette.title,
                lineHeight: 1.2,
              }}
            >
              {kpi.value}
            </div>

            {/* Label */}
            <div
              style={{
                marginTop: 4,
                fontSize: fontSizes.label,
                color: palette.text,
                fontFamily: theme.form.label.fontFamily,
                lineHeight: 1.3,
              }}
            >
              {kpi.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KpiGroup;
